module.exports = __webpack_public_path__ + "static/media/valor2.0aa15b81.png";